import { useCallback, useEffect, useState } from 'react';

import { useWorkstation } from '../../../features/appState';
import { appSubscriptionService, DispenseCompleteEvent } from '../../subscriptions/appSubscriptionService';

import './toast.sass';

interface Toast {
  id: number;
  message: string;
  detail?: string;
}

let toastId = 0;

function ToastNotification() {
  const workstation = useWorkstation();
  const [toasts, setToasts] = useState<Toast[]>([]);

  const removeToast = useCallback((id: number) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const addToast = useCallback(
    (message: string, detail?: string) => {
      const id = ++toastId;
      setToasts((prev) => [...prev, { id, message, detail }]);
      setTimeout(() => removeToast(id), 5000);
    },
    [removeToast],
  );

  useEffect(() => {
    // const completeSub = appSubscriptionService.dispenseCompleteObservable().subscribe((event: DispenseCompleteEvent) => {
    //   // if (workstation?.hasFobReader) return;
    //   const detail = event.tableNumber ? `Table ${event.tableNumber}` : undefined;
    //   addToast(`Order #${event.transactionNumber} ready on ${event.orderDeviceName}`, detail);
    // });

    const readySub = appSubscriptionService.dispenseReadyObservable().subscribe((event: DispenseCompleteEvent) => {
      if (workstation?.hasFobReader) return;
      const detail = event.tableNumber ? `Table ${event.tableNumber}` : undefined;
      addToast(`Order #${event.transactionNumber} ready to serve on ${event.orderDeviceName}`, detail);
    });

    return () => {
      // completeSub.unsubscribe();
      readySub.unsubscribe();
    };
  }, [addToast, workstation?.hasFobReader]);

  if (toasts.length === 0) return null;

  return (
    <div className="pos-toast-container">
      {toasts.map((toast) => (
        <div key={toast.id} className="pos-toast">
          <div className="pos-toast__content">
            <div className="pos-toast__message">{toast.message}</div>
            {toast.detail && <div className="pos-toast__detail">{toast.detail}</div>}
          </div>
          <button className="pos-toast__close" onClick={() => removeToast(toast.id)}>
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}

export default ToastNotification;
